module.exports = __webpack_public_path__ + "static/media/u-hero.02f52744.png";